import {Text, Flex } from "@chakra-ui/react";
import Link from "../components/Link"

import {EditIcon} from "@chakra-ui/icons";
import React from "react";

export default function InfoBox({
  title, value, valueClickHandler, children, editable = false, noBg = false,
  noneValue = "--", ...props
}) {
  // TODO: Rename valueClickHandler to callback.
  const callback = valueClickHandler;
  // Recheck this line.
  props = noBg ? {...props} : { bg: 'gray.200', borderRadius: 5, px: 2, py: 1, ...props}
  let content;
  if (value) {
    const Component = valueClickHandler ? Link : Text;
    content = <Component whiteSpace={'break-spaces'} onClick={() => { callback && callback() }}>{ value }</Component>
  } else {
    if (children) {
      content = children;
    } else {
      content = <Text as="span">{ noneValue }</Text>
    }
  }
  return (
    <Flex fontSize='md' alignItems={'center'} gap={1} flexWrap={'nowrap'} { ...props }>
      { title && <Text fontWeight={'bold'}>{title}</Text>  }
      <Flex alignItems={'center'}>{ editable && <EditIcon /> }{ content }</Flex>
    </Flex>
  );
}
